var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	69108: {
		fallback: () => (() => (__webpack_require__(59862))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "4.16.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@tanstack/react-query",

	},
	95237: {
		fallback: () => (() => (__webpack_require__(28316))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.14.0 || ^15.0.0 || ^16 || ^17 || ^18 || ^19",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	43114: {
		fallback: () => (() => (__webpack_require__(28316))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.0 || ^17.0.0 || ^18.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	73865: {
		fallback: () => (() => (__webpack_require__(28316))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.0 || ^17.0.0-rc.1 || ^18.0.0 || ^19.0.0-rc.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	41028: {
		fallback: () => (() => (__webpack_require__(28316))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.6.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	93681: {
		fallback: () => (() => (__webpack_require__(28316))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=17.x",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	42607: {
		fallback: () => (() => (__webpack_require__(28316))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	43218: {
		fallback: () => (() => (__webpack_require__(28316))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	2314: {
		fallback: () => (() => (__webpack_require__(28316))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	52383: {
		fallback: () => (() => (__webpack_require__(1119))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.2.2",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-oidc-context",

	},
	6618: {
		fallback: () => (() => (__webpack_require__(75362))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.5.2",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-router",

	},
	7811: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.14.0 || ^15.0.0 || ^16 || ^17 || ^18 || ^19",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	24508: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.0 || ^17.0.0 || ^18.0.0 || ^19.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	19917: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.0 || ^17.0.0 || ^18.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	73574: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.0 || ^17.0.0-rc.1 || ^18.0.0 || ^19.0.0-rc.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	97647: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	88629: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">= 16.8",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	4399: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">= 16.x",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	42007: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.13.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	95625: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.6.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	75648: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.8.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	13248: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	57751: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=17.x",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	78727: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	90761: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	57347: {
		fallback: () => (() => (__webpack_require__(2784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [69108,95237,43114,73865,41028,93681,42607,43218,2314,52383,6618,7811,24508,19917,73574,97647,88629,4399,42007,95625,75648,13248,57751,78727,90761,57347];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"179": [
		69108,
		95237,
		43114,
		73865,
		41028,
		93681,
		42607,
		43218,
		2314,
		52383,
		6618,
		7811,
		24508,
		19917,
		73574,
		97647,
		88629,
		4399,
		42007,
		95625,
		75648,
		13248,
		57751,
		78727,
		90761,
		57347
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}